module.exports = __webpack_public_path__ + "static/creation-30fe57181ed789318ab6d7f15888a059.png";